/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelDividendDto } from '../../models/backend-business-angel-dividend-dto';
import { BackendPatchedBusinessAngelDividendRequestDto } from '../../models/backend-patched-business-angel-dividend-request-dto';

export interface VentureFundsBusinessAngelDividendsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedBusinessAngelDividendRequestDto;
}

export function ventureFundsBusinessAngelDividendsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelDividendsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelDividendsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelDividendDto>;
    }),
  );
}

ventureFundsBusinessAngelDividendsPartialUpdate$FormData.PATH = '/api/venture_funds/business-angel-dividends/{id}/';
